{
  "blocks": [
    {
      "id": "module-male-optimization",
      "kind": "module",
      "tags": ["his", "optimization", "sperm", "supplements", "lifestyle"],
      "title": "Sperm Optimization",
      "subtitle": "90-day evidence-based protocol for measurable sperm improvement",
      "icon": "🏋️",
      "body": {
        "duration": "90 days",
        "category": "optimization",
        "forWhom": "him",
        "includes": [
          "Targeted supplement stack (CoQ10, Zinc, Vitamin D, Omega-3)",
          "Lifestyle protocol (heat avoidance, exercise, sleep, alcohol reduction)",
          "Monthly check-ins with progress tracking",
          "Repeat semen analysis at 90 days to measure improvement",
          "Optional: DNA fragmentation panel for deeper insight"
        ],
        "trackableMarkers": [
          {
            "name": "Sperm count",
            "expectedToChange": true,
            "expectation": "Responds meaningfully to heat avoidance, alcohol reduction, and supplements. Expect measurable change at 90 days.",
            "retestInterval": "90 days"
          },
          {
            "name": "Motility",
            "expectedToChange": true,
            "expectation": "Often the first parameter to improve. Progressive motility should be >32% (WHO reference).",
            "retestInterval": "90 days"
          },
          {
            "name": "DNA fragmentation",
            "expectedToChange": true,
            "expectation": "Responsive to antioxidants and lifestyle changes. Not part of standard SA. Must be ordered separately.",
            "retestInterval": "90 days"
          },
          {
            "name": "Morphology",
            "expectedToChange": true,
            "expectation": "Least responsive parameter, but can shift modestly. Many REs focus more on count and motility.",
            "retestInterval": "90 days"
          }
        ],
        "priceRange": {
          "low": 200,
          "high": 500
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Start supplements",
            "description": "CoQ10 (200mg), Zinc (30mg), Vitamin D (2000–4000 IU), Omega-3. Targeting the full 74-day sperm cycle."
          },
          {
            "title": "Lifestyle changes",
            "description": "Avoid hot tubs/saunas, laptop on lap, tight underwear. Reduce alcohol. Exercise moderately."
          },
          {
            "title": "Monthly check-in",
            "description": "Track adherence, energy, and any side effects. Adjust protocol as needed."
          },
          {
            "title": "90-day retest",
            "description": "Repeat semen analysis to measure count, motility, and morphology changes against your baseline."
          }
        ]
      },
      "sources": [
        {
          "title": "The effect of antioxidant supplementation on sperm parameters: a systematic review",
          "journal": "Reproductive BioMedicine Online",
          "year": 2022,
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
